// extracted by mini-css-extract-plugin
export default {"container":"AddContactPerson_container__e-c8o","avatar":"AddContactPerson_avatar__y7SiT","content":"AddContactPerson_content__y0Zhc"};